import type { MouseEvent } from 'react'

import { Computed, Observer } from 'shared/observer'

let isOpen = false
let menu: HTMLDivElement | null = null

const lastTrigger = new Observer<HTMLButtonElement | null>(null)

const openId = new Computed(lastTrigger, button => button?.value ?? '')

function manualSet(element: typeof menu) {
	menu = element
}

function openActions(event: MouseEvent<HTMLButtonElement>) {
	const trigger = event.currentTarget

	const isTheSame = lastTrigger.value === trigger
	lastTrigger.value = trigger

	if (menu) {
		if (isTheSame) {
			isOpen ? menu.hidePopover() : menu.showPopover()
			isOpen = !isOpen
		} else {
			isOpen = true
			menu.showPopover()
		}
	}
}

const close = () => {
	isOpen = false
	menu?.hidePopover()
}

export { close, manualSet, menu, openActions, openId }
